import React from "react"
import ReactDOM from "react-dom"

import App from "./App.js"

// import cartAdder from "./redux/addToCart/cartAdder"

// cartAdder()

ReactDOM.render(<App />, document.getElementById("root"))